import { useContext, useState } from 'react';
import { useEffect } from 'react';
import { createContext } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { apiJalles } from '../services/api';
import { HomeContext } from './contexHome';

export const TanqueContext = createContext({});

export const TanqueProvider = () => {
  const [modalStatus, setModalStatus] = useState(false);
  const [modalAlertas, setModalAlertas] = useState(false);
  const [dataNivelTanques, setDataNivelTanques] = useState([]);
  const [graficoInfo, setGraficoInfo] = useState(dataNivelTanques);
  const [alertJalles, setAlertJalles] = useState([]);
  const [bombasTanquesJalles, setBombasTanquesJalles] = useState([]);
  const [statusTanque, setStatusTanque] = useState([]);
  const [modalConfimetionBomba, setModalConfimationBomba] = useState(false);
  const [salveBombaFuntion, setSalveBombaFuntion] = useState([]);
  const [loading, setLoaing] = useState(false);
  const [modalValvula, setModalValvula] = useState(false);

  const { user } = useContext(HomeContext);

  const navigate = useNavigate();

  const token = sessionStorage.getItem('connectionsToken');
  const headerApi = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const listMedicoesTanquesJalles = async () => {
    try {
      setLoaing(true);
      const response = await apiJalles.get('medicoestanquesjalles/', headerApi);
      setDataNivelTanques(response.data);
    } catch (error) {
    } finally {
      setLoaing(false);
    }
  };

  const listMedicoesTanquesUol = async () => {
    try {
      setLoaing(true);
      const response = await apiJalles.get('medicoestanquesuol/', headerApi);
      setDataNivelTanques(response.data);
    } catch (error) {
    } finally {
      setLoaing(false);
    }
  };

  const listHistoricoTanque = async (tanqueName) => {
    try {
      setLoaing(true);
      const response = await apiJalles.get(`${tanqueName}/`, headerApi);
      setGraficoInfo(response.data);
    } catch (error) {
    } finally {
      setLoaing(false);
    }
  };

  const AlertasJalles = async () => {
    try {
      const response = await apiJalles.get('alertastanquesjalles/', headerApi);
      setAlertJalles(response.data);
    } catch (error) {}
  };

  const AlertasUol = async () => {
    try {
      const response = await apiJalles.get('alertastanquesuol/', headerApi);
      setAlertJalles(response.data);
    } catch (error) {
      if (error.request.status === 403) {
        sessionStorage.removeItem('connectionsToken');
        sessionStorage.removeItem('connectionsUnit');
        navigate('/Login');
      }
    }
  };

  const BombasJalles = async () => {
    try {
      const response = await apiJalles.get('bombasjalles/', headerApi);
      setBombasTanquesJalles(response.data);
    } catch (error) {}
  };

  const BombasUol = async () => {
    try {
      const response = await apiJalles.get('bombasuol/', headerApi);
      setBombasTanquesJalles(response.data);
    } catch (error) {}
  };

  const statusTanquesJalles = async () => {
    try {
      const response = await apiJalles.get('statusjalles/', headerApi);
      setStatusTanque(response.data);
    } catch (error) {}
  };

  const statusTanquesUol = async () => {
    try {
      const response = await apiJalles.get('statusuol/', headerApi);
      setStatusTanque(response.data);
    } catch (error) {}
  };

  const ligarBombasJM = async (data, id) => {
    try {
      if (!user.is_superuser && !user.is_staff) {
        throw new Error('Usuario não autorizado');
      }
      const response = await apiJalles.patch(`bombasjalles/${id}/`, data, headerApi);
      setBombasTanquesJalles((prevList) => {
        return prevList.map((item) => (item.id === id ? { ...item, ...response.data } : item));
      });
      toast.success('Comando Feito com sucesso', {
        position: 'top-right',
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'dark',
      });
    } catch (error) {
      if (error.message === 'Usuario não autorizado') {
        toast.warn('😅Sem autorização para realizar esta ação', {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'dark',
        });
      } else {
        toast.warn('😅Algo de Errado', {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'dark',
        });
      }
    } finally {
      setModalConfimationBomba(false);
    }
  };

  const ligarBombasUol = async (data, id, teste) => {
    try {
      if (!user.is_superuser && !user.is_staff) {
        throw new Error('Usuario não autorizado');
      }
      const response = await apiJalles.patch(`bombasuol/${id}/`, data, headerApi);
      setBombasTanquesJalles((prevList) => {
        return prevList.map((item) => (item.id === id ? { ...item, ...response.data } : item));
      });
      toast.success('Comando Feito com sucesso', {
        position: 'top-right',
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'dark',
      });
    } catch (error) {
      if (error.message === 'Usuario não autorizado') {
        toast.warn('😅Sem autorização para realizar esta ação', {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'dark',
        });
      } else {
        toast.warn('😅Algo de Errado', {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'dark',
        });
      }
    } finally {
      if (teste === ' ') {
        setModalValvula(false);
      } else {
        setModalConfimationBomba(false);
      }
    }
  };

  useEffect(() => {}, []);

  return (
    <TanqueContext.Provider
      value={{
        modalStatus,
        setModalStatus,
        dataNivelTanques,
        listHistoricoTanque,
        graficoInfo,
        setGraficoInfo,
        alertJalles,
        modalAlertas,
        setModalAlertas,
        bombasTanquesJalles,
        listMedicoesTanquesJalles,
        AlertasJalles,
        BombasJalles,
        listMedicoesTanquesUol,
        AlertasUol,
        BombasUol,
        statusTanquesJalles,
        statusTanque,
        statusTanquesUol,
        ligarBombasJM,
        modalConfimetionBomba,
        setModalConfimationBomba,
        salveBombaFuntion,
        setSalveBombaFuntion,
        loading,
        ligarBombasUol,
        modalValvula,
        setModalValvula,
      }}
    >
      <Outlet />
    </TanqueContext.Provider>
  );
};

export const TanqueContextC = createContext({});

export const NTanqueProvider = () => {
  const { socket } = useContext(HomeContext);

  const [modalStatus, setModalStatus] = useState(false);
  const [tanquesList, setTanquesList] = useState(null);
  const [modalAlertas, setModalAlertas] = useState(false);
  const [alertaList, setAlertaList] = useState([]);
  const [modalConfimetionBomba, setModalConfimationBomba] = useState(false);
  const [idControlerBomba, setIdControlerBomba] = useState(null);
  const [modalVazao, setModalVazao] = useState(false);

  return (
    <TanqueContextC.Provider
      value={{
        socket,
        setModalAlertas,
        modalAlertas,
        alertaList,
        setAlertaList,
        modalStatus,
        setModalStatus,
        tanquesList,
        setTanquesList,
        modalConfimetionBomba,
        setModalConfimationBomba,
        idControlerBomba,
        setIdControlerBomba,
        modalVazao,
        setModalVazao,
      }}
    >
      <Outlet />
    </TanqueContextC.Provider>
  );
};
